import React from 'react';
import $ from 'jquery';
import Utility from '../utilities/utility';
import AuthorizationCheck from '../auth/authorizationCheck';
import placeholder from '../placeholder.png';
import ProductGallery from './productGallery';
import ProductService from '../services/product';

class UpdateProduct extends React.Component {
    constructor(props) {
        super(props);

        //const queryParams = new URLSearchParams(window.location.search);

        this.state = {


            product: [],
            currentUserRole: '',
            selectedFile: null,
            base64Image: "",
            preview: "",
        }
    }

    componentDidMount() {

        this.fetchProduct();
    }

    handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    this.setState({ selectedFile: file, message: "" });

    const reader = new FileReader();

    reader.onloadend = () => {
      const base64String = reader.result; // includes data:image/jpeg;base64,...
      this.setState({
        base64Image: base64String,
        preview: base64String
      });
    };

    reader.readAsDataURL(file);
  };



    async fetchProduct() {

        try {

            let productId = $('#selectedProductId').val();

            const response = await this.props.productService.fetchProduct(productId);

            this.setState({

                product: await response.json()
            });
        } catch (error) {
            console.log(error);
        }




    }

    setRole = (role) => {

        this.setState({ currentUserRole: role });
    }

    addProductImage = async(imageName, imageBase64) => {

        let product = this.state.product;

        const response  = await ProductService.addProductImage(product.id, imageName, imageBase64);


        if(response.ok){

            const productImage = await response.json();

            let images = product.images;

            images.unshift(productImage);

            product.images = images;
            this.setState({ product: product });

            this.props.updateProductImage(product);

            return;

        }

        

        

    }

    removeProductImage = async(imageId) => {

        const response  = await ProductService.removeProductImage(imageId);


        if(response.ok){

            console.log('Image removed')

            return;

        }
    }

    setProductImageAsMain = async(imageId) => {

        const response  = await ProductService.setProductImageAsMain(imageId);


        if(response.ok){

            console.log('Image set as main')

            return;

        }
    }


    render() {



        if (Utility.isEmpty(this.state.product)) {

            return ('Not found');
        }

        const product = this.state.product;

        const fileName = this.state.selectedFile ? this.state.selectedFile.name : ""


        return (
            <div className="container update-product-wrapper mt-4">

                <AuthorizationCheck accessLevel='ADMIN' userRole={this.setRole} />


                <h2 className="mb-3 text-center">Mis a jour du Produit </h2>


                <div className="form-wrapper">


                    <div className="messageHolder"></div>

                    

                   <ProductGallery 
                   images={product.images} 
                   addProductImage = {this.addProductImage} 
                   removeImage = {this.removeProductImage} 
                   setImageAsMain={this.setProductImageAsMain} />



                    <div className="form-group">
                        <label className="label">Nom</label>
                        <input className="form-control" id="uname" defaultValue={product.name} placeholder="Nom" />
                    </div>


                    <div className="form-group">
                        <label className="label">Model</label>
                        <input className="form-control" id="umodel" defaultValue={product.model} placeholder="Model" />
                    </div>




                    <div className="form-group">
                        <label className="label">Marque</label>
                        <input className="form-control" id="ubrand" defaultValue={product.brand} placeholder="Marque" />
                    </div>

                    <div className="form-group">
                        <label className="label">Couleur</label>
                        <input className="form-control" id="color" defaultValue={product.color} placeholder="Couleur" />
                    </div>


                    <div className="form-group">
                        <label className="label">Numero</label>
                        <input className="form-control" id="usize" defaultValue={product.size} placeholder="Numero" />
                    </div>

                    <div className="form-group">
                        <label className="label">PRIX</label>
                        <input className="form-control" id="price" defaultValue={product.price} placeholder="PRIX" />
                    </div>

                    <div className="form-group">
                        <label className="label">PRIX Client</label>
                        <input className="form-control" id="customerPrice" defaultValue={product.customerPrice} placeholder="PRIX Client" />
                    </div>

                    <div className="form-group">
                        <label className="label">CBM</label>
                        <input className="form-control" id="cbm" defaultValue={product.cbm} placeholder="CBM" />
                    </div>

                    <div className="form-group">
                        <label className="label">Quantité par Carton</label>
                        <input className="form-control" id="qtyInBox" defaultValue={product.boxQuantity} placeholder="Qté dans le carton" />
                    </div>

                    <div className="form-group">
                        <label className="label">Poids</label>
                        <input className="form-control" id="weight" defaultValue={product.weight} placeholder="Poids" />
                    </div>

                    <div className="form-group">
                        <div className="messageHolder"></div>
                        <label className="label">CPID</label>
                        <input className="form-control" id="supplierUniqueId" defaultValue={product.supplierUniqueId} placeholder="CPID" />
                    </div>


                    <div className="form-group">
                        <button className="btn btn-primary full-width" onClick={() => this.props.updateProduct(product.id)}>Enregistrer</button>
                    </div>


                </div>



            </div>
        )
    }

}

export default UpdateProduct;